import { EventDispatcher } from "../services/EventDispatcher";

export class Logger {

    static OFF = 0;
    static ERROR = 1;
    static WARNING = 2;
    static SUCCESS = 3;
    static INFO = 4;
    static TRACE = 5;

    static NAMES = ['OFF', 'ERROR', 'WARNING', 'SUCCESS', 'INFO', 'TRACE'];

    constructor() {

        this.level = Logger.LEVEL_WARNING;

        this._onLogEvent = new EventDispatcher();
        this.onLog = this._onLogEvent.subscribeHandler();

    }

    // --------------------------------------------------------------------------------------------

    log(level, message, data = null, source = null, suppressNotification = false) {

        if (this.level < level)
            return;

        var text = Logger.NAMES[level] + (source ? ' [' + source + ']' : '') + ' ' + message;
        if (data)
            text = text + ' --> ' + JSON.stringify(data);
        switch (level) {
            case Logger.ERROR:
                console.error(text);
                break;
            case Logger.WARNING:
                console.warn(text);
                break;
            case Logger.SUCCESS:
                console.info(text);
                break;
            default:
                console.log(text);
                break;
        }

        if (!suppressNotification)
            this._onLogEvent.dispatch({ level: level, message: message, data: data, source: source });

    };

    // --------------------------------------------------------------------------------------------

    exception(message, exception, source, suppressNotification) {

        var msg = message;
        if (exception)
            msg += ':' + (exception.message ? '\n' + exception.message : '') + (exception.trace ? '\n' + exception.trace : '');

        this.log(Logger.ERROR, msg, null, source, suppressNotification);

    };

    error(message, data, source, suppressNotification) {

        this.log(Logger.ERROR, message, data, source, suppressNotification);

    };

    warning(message, data, source, suppressNotification) {

        this.log(Logger.WARNING, message, data, source, suppressNotification);

    };

    success(message, data, source, suppressNotification) {

        this.log(Logger.SUCCESS, message, data, source, suppressNotification);

    };

    info(message, data, source, suppressNotification) {

        this.log(Logger.INFO, message, data, source, suppressNotification);

    };

    trace(message, data, source) {

        this.log(Logger.TRACE, message, data, source, false);

    };


}

export const instance = new Logger();